import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/tomos';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-20" data-mp="1lazal8l2t7cu">
      <div className="mx-auto max-w-3xl px-5" data-id="element-21" data-mp="1l9ft5enooq9h">
        <h2 className="text-2xl font-black leading-tight tracking-tight text-ink sm:text-[2rem]" data-id="element-22" data-mp="1gdqpp08jmp7w">
          Preguntas frecuentes
        </h2>

        <dl className="mt-8 divide-y divide-paper-line border-y border-paper-line" data-id="element-23" data-mp="2dyd9hc8c4czl">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          return <div key={faq.pregunta} data-id="element-24" data-mp="240fem5vyzhy0" data-mpi={index}>
                <dt data-id="element-25" data-mp="1z3fe0ahw37ea">
                  <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-flame" data-id="element-26" data-mp="1z25gbmey8186">
                    <span className="text-base font-bold text-ink sm:text-lg" data-id="element-27" data-mp="uh0vg9f46nn3">
                      {faq.pregunta}
                    </span>
                    {open ? <MinusIcon className="h-5 w-5 shrink-0 text-flame" aria-hidden="true" data-id="element-28" data-mp="fji6p72fsafn" /> : <PlusIcon className="h-5 w-5 shrink-0 text-ink-muted" aria-hidden="true" data-id="element-29" data-mp="6pvefqxftpb7" />}
                  </button>
                </dt>
                {open && <dd className="pb-5 pr-10 text-base leading-relaxed text-ink-soft" data-id="element-30" data-mp="1rk8hra9jyy9">
                    {faq.respuesta}
                  </dd>}
              </div>;
        })}
        </dl>
      </div>
    </section>;
}